import { parseRoutingFromEnv, resolveWriteRepo } from './writeRouting';

export class CompositeLicenseRepository {
  constructor({ firestoreRepo, apiRepo, writeRouting = {} }) {
    this.firestoreRepo = firestoreRepo;
    this.apiRepo = apiRepo;
    this.writeRouting = {
      defaultTarget: writeRouting.defaultTarget || 'firestore',
      operationTargets: writeRouting.operationTargets || {}
    };
  }

  writeRepoFor(operation) {
    return resolveWriteRepo({
      routing: this.writeRouting,
      operation,
      firestoreRepo: this.firestoreRepo,
      apiRepo: this.apiRepo,
      scopeName: 'LicenseRepository'
    });
  }

  searchLicenses(cityId, options) {
    return this.apiRepo.searchLicenses(cityId, options);
  }

  mapMarkers(cityId) {
    return this.apiRepo.mapMarkers(cityId);
  }

  exportLicenses(cityId, options) {
    return this.apiRepo.exportLicenses(cityId, options);
  }

  createLicense(cityId, payload) {
    return this.writeRepoFor('createLicense').createLicense(cityId, payload);
  }

  updateLicense(cityId, licenseId, payload) {
    return this.writeRepoFor('updateLicense').updateLicense(cityId, licenseId, payload);
  }

  updateLicenseId(cityId, licenseId, payload) {
    return this.apiRepo.updateLicenseId(cityId, licenseId, payload);
  }

  updateLicenseProperty(cityId, licenseId, payload) {
    return this.writeRepoFor('updateLicenseProperty').updateLicenseProperty(cityId, licenseId, payload);
  }

  updateLicenseContact(cityId, licenseId, payload) {
    return this.writeRepoFor('updateLicenseContact').updateLicenseContact(cityId, licenseId, payload);
  }

  updateLicenseApplicationAnswers(cityId, licenseId, payload) {
    return this.apiRepo.updateLicenseApplicationAnswers(cityId, licenseId, payload);
  }

  updateLicenseStatusAndDates(cityId, licenseId, payload) {
    return this.writeRepoFor('updateLicenseStatusAndDates').updateLicenseStatusAndDates(cityId, licenseId, payload);
  }

  saveLicense(cityId, licenseId, data) {
    return this.writeRepoFor('saveLicense').saveLicense(cityId, licenseId, data);
  }

  deleteLicense(cityId, licenseId) {
    return this.writeRepoFor('deleteLicense').deleteLicense(cityId, licenseId);
  }

  updateLicenseApplication(cityId, applicationId, patch) {
    return this.writeRepoFor('updateLicenseApplication').updateLicenseApplication(cityId, applicationId, patch);
  }

  addReport(cityId, data) {
    return this.writeRepoFor('addReport').addReport(cityId, data);
  }

  importLicenses(cityId, payload) {
    return this.apiRepo.importLicenses(cityId, payload);
  }
}

export function getLicenseWriteRoutingFromEnv(env = process.env) {
  const routing = parseRoutingFromEnv({
    env,
    defaultTargetKeys: [
      'VUE_APP_LICENSE_WRITE_REPOSITORY',
      'VUE_APP_CITY_WRITE_REPOSITORY',
      'VUE_APP_CITY_WRITE_TARGET'
    ],
    operationTargetsKeys: [
      'VUE_APP_LICENSE_WRITE_REPOSITORY_BY_OPERATION',
      'VUE_APP_CITY_WRITE_REPOSITORY_BY_OPERATION'
    ]
  });

  const saveLicenseTarget = routing.operationTargets.saveLicense;
  if (saveLicenseTarget) {
    routing.operationTargets.createLicense = routing.operationTargets.createLicense || saveLicenseTarget;
    routing.operationTargets.updateLicense = routing.operationTargets.updateLicense || saveLicenseTarget;
  }

  // These workflows depend on server validation and side effects; C's rules reject direct writes.
  for (const operation of [
    'createLicense',
    'updateLicense',
    'updateLicenseProperty',
    'updateLicenseContact',
    'updateLicenseStatusAndDates'
  ]) {
    routing.operationTargets[operation] = 'api';
  }

  return routing;
}
